/* eslint-disable */
import { RequestBulkBooking, RequestDetailRepairBulkBooking } from "@/data/payload/api/BulkApiRequest";
import { BalanceReportMutationApiRequest } from "@/domain/entities/Balance";
import { RequestApiClientMappingList } from "@/domain/entities/Client";
import {
  RequestApiElexysFailedBookingList,
  RequestDownloadElexysFailedBooking,
} from "@/domain/entities/IntegrationMonitoring";
import {
  ApiRequestList,
  QueryParamsEntities,
  QueryParamsEntities2,
} from "@/domain/entities/MainApp";
import { RequestListOnProcessStt } from "@/data/payload/api/OnProcessApiRequest";
import {
  ReportApiRequest,
  ReportListDownloadRequest,
} from "@/domain/entities/Report";
import {
  PrintDetailRequest,
  RequestEstimateSlaDetail,
  RequestEstimationServiceLevelAgreement,
  RequestListBooking,
  SttDetailRequest
} from "@/data/payload/api/BookingRequest";
import { RequestListManualStt } from "@/data/payload/api/ManualSTTApiRequest";
import {
  CodDashboardCourierDetailRequest,
  DashboardConsoleRequest,
  DashboardDetailListRequest,
  DashboardDownloadRequest,
  DownloadSummaryCodRequest,
} from "@/data/payload/api/DashboardRequests";
import { RequestBookingCommissionList } from "@/data/payload/api/BookingCommissionApiRequest";
import { RequestListAnnouncement } from "@/data/payload/api/AnnouncementApiRequest";
import { RequestMessagingServiceConfigurationList } from "@/data/payload/api/MessagingServiceConfigurationApiRequest";
import {
  ReasonListDex,
  RequestListPodDex,
} from "@/data/payload/api/PodDexRequest";
import {
  RequestExportFileExcel,
  RequestListHandover,
  RequestPartnerVendorList,
} from "@/data/payload/api/HandoverApiRequest";
import {
  STIReverseScanTemporaryListRequest,
  STISTTDueListRequest,
  STISTTDueSummaryListRequest,
  StiListRequest,
} from "@/data/payload/api/StiApiRequest";
import { RequestListUser } from "@/data/payload/api/UserApiRequest";
import { RequestListCommodity } from "@/data/payload/api/CommodityApiRequest";
import { RequestListCustomProcess } from "@/data/payload/api/CustomProcessApiRequest";
import { RequestListBalanceTransaction } from "@/domain/entities/BalanceTransaction";
import { RequestListPartner } from "@/data/payload/api/PartnerApiRequest";
import { RequestListLastBalance } from "@/data/payload/api/LastBalanceApiRequest";
import { LastBalanceDownloadRequest } from "@/domain/entities/LastBalance";
import {
  RequestListClientManagement,
  RequestUpdateCurrentRates,
} from "@/data/payload/api/ClientManagementApiRequest";
import { RequestDownloadIncomingOutgoing } from "@/domain/entities/IncomingOutgoing";
import { RequestListPaymentMethod } from "@/data/payload/api/PaymentApiRequest";
import { RequestList } from "@/domain/entities/ResponsePayload";
import { BonusKomisiDetailRequest } from "@/data/payload/api/ProgressiveCommissionDashboardRequest";
import { ProgressiveCommissionListRequest } from "@/data/payload/api/ProgressiveCommissionConfigurationApiRequest";
import { StiDestListRequest } from "@/data/payload/api/StiDestApiRequest";
import { BaggingDisputeSummaryRequest, BaggingListRequest } from "@/data/payload/api/BaggingApiRequest";
import {
  CargoListRequest,
  CargoMinimumWeightSummaryApiRequest,
  CargoRecomendationsListRequest,
  CargoSummaryInProcessRequest,
  SearchFlightRequest,
  FailedUnreadRequest
} from "@/data/payload/api/CargoApiRequest";
import { ClientBookingListParams } from "@/data/payload/api/BulkBookingApiRequest";
import { RequestBaggingGroupingList } from "@/data/payload/api/BaggingGroupingApiRequest";
import { ClaimListRequest } from "@/data/payload/api/ClaimRequest";
import { CheckTariffRequest } from "@/data/payload/api/TariffApiRequest";
import { TrackDeliveryListRequest } from "@/data/payload/api/TrackDeliveryApiRequest";
import { RequestHistoryPoinSaldoList } from "@/data/payload/api/SaldoPoinApiRequest";
import { CargoConfigListRequest } from "@/data/payload/api/CargoConfigurationApiRequest";
// import {
//   CargoConfigV2ListRequest,
//   CargoConfigV2SearchFlightRequest
// } from "@/data/payload/api/CargoConfigV2ApiRequest";
// import { WoodpackingConfigListRequest } from "@/data/payload/api/WoodpackingConfigApiRequest";
import { DutyTaxConfigurationListRequest } from "@/data/payload/api/DutyTaxConfigurationApiRequest";
// import { WoodpackingEligibilityQuery } from "@/data/payload/api/BookingRequest";
import isUrlUpdateVersion from "@/app/infrastructures/misc/common-library/IsUrlUpdateVersion";
import { IS_SENDER_ACCOUNT } from "@/app/infrastructures/misc/Constants";
import { RequestListRouteLeg } from "@/data/payload/api/LegApiRequest";
import {
  DistrictClientRequest,
  RegionListRequest,
} from "@/data/payload/api/LocationRequest";
import {
  RequestListSTISCSession,
  RequestListSTISC,
} from "@/domain/entities/StiSc";
import {
  ApiRequestCourierManagementList,
  ApiRequestCourierManagementListHistory,
  ApiRequestCourierVehicleList,
} from "@/data/payload/api/CourierManagementApiRequest";
import { RequestSttPaidUnread } from "@/domain/entities/STTPaidUnpaid";
import { FlagsDashboardCod } from "@/feature-flags/dashboard/cod";
import { StringValueToken } from "html2canvas/dist/types/css/syntax/tokenizer";
import { GetListBalanceApiRequest } from "@/data/payload/api/BalanceRequest";
import { RequestMiddlewareList } from "@/data/payload/api/MiddlewareApiRequest";
import { CashbackListRequest } from "@/domain/entities/CashbackConfiguration";
import { RequestTopupFeeConfigurationList } from "@/domain/entities/TopupFeeConfiguration";
import { STISCReverseScanTemporaryListRequest, STIScSTTDueListRequest, STISCSTTDueSummaryRequest } from "@/data/payload/api/StiScApiRequest";
import {
  UrgentDeliveryManagementPODListRequest,
  UrgentDeliveryManagementRTSListRequest,
  UrgentDeliveryManagementHALListRequest,
  UrgentDeliveryManagementPODListRequestDownload,
  UrgentDeliveryManagementRTSListRequestDownload,
  UrgentDeliveryManagementHALListRequestDownload,
  UrgentDeliveryManagementPODSummaryRequest,
  UrgentDeliveryManagementMissingListRequestDownload,
  UrgentDeliveryManagementRelabelListRequest,
  UrgentDeliveryManagementRelabelListRequestDownload
} from "@/domain/entities/UrgentDeliveryManagement";
import { CourierDetailApiRequest, SettlementListRequest } from "@/domain/entities/CodReconcile";
import { RequestListNeedToSTIDestDel, RequestListSTIDestTemporary } from "@/domain/entities/StiDest";
import { STTDetail } from "@/domain/entities/CustomProcess";
import { getHubData } from "./Cookies";
import { CourierShuttleListRequest } from "@/domain/entities/CourierShuttle";
import { FlagsPermissionCargo } from '@/feature-flags/flags-permission-cargo';
import { TaskSettlementCourierParams } from "@/data/payload/api/CodReconcileApiRequest";
import { FlagsPermissionCodBalanceSwitchToFcs } from "@/feature-flags/flags-permission-cod-balance";
import { RequestListLastBalanceV2 } from "@/data/payload/api/LastBalanceV2ApiRequest";
import { ListRatesApiRequest } from "@/data/payload/api/BaseRatesApiRequest";
import { ClientRateHistoryApiRequest } from "@/data/payload/api/ClientRegistrationApiRequest";
import { FlagsPermissionBagging } from "@/feature-flags/flags-permission-bagging";


const IS_NGEN_V2: boolean = !!String(
  process.env.VUE_APP_NGEN_GENESIS_API_URL_VERSION
).match(/v2/gi);

export class Endpoints {
  public static baseUrl = process.env.VUE_APP_GENESIS_API_URL;
  public static baseUrlPrivate = process.env.VUE_APP_GENESIS_PRIVATE_API_URL;
  public static baseUrlAlgo = process.env.VUE_APP_ALGO_API_URL;
  public static baseUrlNGen = IS_NGEN_V2
    ? process.env.VUE_APP_NGEN_GENESIS_API_URL_DEV_V2
    : process.env.VUE_APP_NGEN_GENESIS_API_URL_DEV_V1;

  login(version: string): string {
    return `/horde/${version}/auth/login`;
  }

  forgotPassword() {
    return "/horde/v1/auth/reset_password";
  }

  resetPassword() {
    return "/horde/v1/auth/change_password_token";
  }

  validateSetupPasswordLink() {
    return "/horde/v1/auth/validate-token";
  }

  setupPassword() {
    return "/horde/v1/auth/setup-password";
  }

  resendSetupPasswordLink() {
    return "/horde/v1/auth/resend-setup-password";
  }

  logout() {
    return "/horde/v1/auth/logout";
  }

  deviceAuth(): string {
    return "/horde/v1/auth"
  }

  deviceAuthCheckApproval() {
    return "/horde/v1/device-auth/check-approval";
  }

  verificationAccount() {
    return "/horde/v2/auth/verify";
  }

  requestOtp() {
    return "/horde/v2/auth/validate-account";
  }

  login2fa(): string {
    return "/horde/v1/2fa/login";
  }

  login2faOtpRequest(): string {
    return "/horde/v1/2fa/otp/request";
  }

  login2faOtpVerify(): string {
    return "/horde/v1/2fa/otp/verify";
  }

  getListBulk(
    activity_name: string,
    archive_name: string,
    status: string,
    page: number,
    limit: number
  ) {
    return `/horde/v1/bulk?search=${encodeURIComponent(
      activity_name
    )}&archive_type=${archive_name}&status=${status}&page=${page}&limit=${limit}`;
  }


  bulkUpload(version = "v1"): string {
    return `/horde/${version}/bulk`;
  }


  bulkCustomerUpload(): string {
    return "/horde/v1/customer/bulk";
  }

  editPassword(version = "v1"): string {
    return `/horde/${version}/auth/change_password`;
  }

  getProfile(isLocation?: boolean, cache?: boolean): string {
    return `/horde/v1/account/profile?cache=${cache}&is_location=${isLocation}`;
  }

  unpairToken() {
    return "/horde/v1/account/unpair-token";
  }

  getValidationAccount(): string {
    return "horde/v1/auth/validation-access";
  }

  pairToken() {
    return "/horde/v1/account/pair-token";
  }

  getAccountStatus(accountId: number): string {
    return `horde/v1/cs-account-status/${accountId}`;
  }
  postCsAccountLog(): string {
    return "horde/v1/cs-account-log";
  }

  getListCity(
    search: string,
    status: string,
    page: number,
    limit: number
  ): string {
    return `/horde/${isUrlUpdateVersion(
      "city"
    )}/city?search=${encodeURIComponent(
      search
    )}&status=${status}&page=${page}&limit=${limit}`;
  }
  getListCityV2(params: ApiRequestList): string {
    return `/horde/${isUrlUpdateVersion("city")}/city${
      params.newEndpoint ? "/list" : ""
    }?${params.toQueryString()}`;
  }

  getDistrictListByCityCode(cityCode: string, page: number, limit: number, search: string): string {
    return `/horde/v1/district/list?city_code=${cityCode}&page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`;
  }

  getListCityFTZ(
    search: string,
    status: string,
    page: number,
    limit: number,
    freeTradeZone: string
  ): string {
    return `/horde/${isUrlUpdateVersion(
      "city"
    )}/city?search=${encodeURIComponent(
      search
    )}&status=${status}&page=${page}&limit=${limit}&free_trade_zone=${freeTradeZone}`;
  }

  getDetailCity(id: number): string {
    return `/horde/v1/city/${id}`;
  }

  getListCountry(
    search: string,
    status: string,
    page: number,
    limit: number
  ): string {
    return `/horde/v1/country?search=${encodeURIComponent(
      search
    )}&status=${status}&page=${page}&limit=${limit}`;
  }

  getDetailCountry(id: number): string {
    return `/horde/v1/country/${id}`;
  }

  getListDistrict(
    search: string,
    status: string,
    page: number,
    limit: number,
    excludeCountry: string,
    type: string,
    cityCode = "",
    countryCode = "",
    cache: boolean,
    isCod = "",
    isMisbookingPotential = ""
  ): string {
    const version = IS_SENDER_ACCOUNT ? "v1" : "v3";
    return `/horde/${version}/district?cache=${cache}&search=${encodeURIComponent(
      search
    )}&status=${status}&page=${page}&limit=${limit}&exclude_country=${excludeCountry}&type=${type}&city_code=${cityCode}&country_code=${countryCode}&is_cod=${isCod}&is_misbooking_potential=${isMisbookingPotential}`;
  }

  getDetailDistrict(id: number): string {
    return `/horde/v1/district/${id}`;
  }

  getDetailDistrictByDistrictCode(str: string) {
    return `/horde/v1/district/code/${str}`;
  }

  editCity(id: number): string {
    return `/horde/v1/city/${id}`;
  }

  editCountry(id: number): string {
    return `/horde/v1/country/${id}`;
  }

  getUrsaCode(ursaCode: string) {
    return `/horde/v1/district/ursa-code?ursa_code=${ursaCode}`;
  }

  editDistrict(id: number): string {
    return `/horde/v1/district/${id}`;
  }

  getListDistrictZipCode(search: string, page: number, limit: number, countryCode = "") {
    return `/horde/v1/district/zip-code?search=${encodeURIComponent(
      search
    )}&page=${page}&limit=${limit}&country_code=${countryCode}`;
  }

  getListUser(params: RequestListUser): string {
    return `/horde/v${params.version}/account?${params.toQueryString()}`;
  }

  getDetailUser(id: number): string {
    return `/horde/v1/account/detail/${id}`;
  }

  editUser(): string {
    return `/horde/v1/account`;
  }

  getUnreadNotification(cache: boolean) {
    return `/horde/v1/notification/unread/me?cache=${cache}`;
  }

  getNotifications(
    page: number,
    limit: number,
    status: string,
    search: string,
    isPinned: number,
    sort: string,
    cache: boolean
  ) {
    return `/horde/v1/notification/me?cache=${cache}&search=${encodeURIComponent(
      search
    )}&limit=${limit}&page=${page}&sort=${sort || "desc"}`;
  }

  readNotification() {
    return "/horde/v1/notification/read";
  }

  detailNotification(id: number) {
    return `/horde/${isUrlUpdateVersion("announcement")}/announcement/${id}`;
  }

  editAnnouncement(id: number) {
    return `/horde/v1/announcement/${id}`;
  }

  getReference(account_type: string, search: string): string {
    const accountType = account_type.split("_");
    if (accountType.length > 1) {
      return `/horde/v1/account/reference?page=1&limit=10&account_type=${
        accountType[0]
      }&reference_client_type=${accountType[1]}&search=${encodeURIComponent(
        search
      )}`;
    }
    return `/horde/v1/account/reference?page=1&limit=10&account_type=${account_type}&search=${encodeURIComponent(
      search
    )}`;
  }

  getDivision(search: string) {
    return `/horde/v1/departments/by-division?search=${encodeURIComponent(
      search
    )}`;
  }

  getShuttle(search: string, hubId: number, partnerId: number) {
    return `/horde/v1/shuttle?hub_id=${hubId}&partner_id=${partnerId}&search=${encodeURIComponent(
      search
    )}`;
  }

  getRole(account_type: string): string {
    const accountType = account_type.split("_");
    if (accountType.length > 1) {
      return `/horde/v1/account/role?page=1&limit=50&account_type=${accountType[0]}&account_role_client_type=${accountType[1]}`;
    }
    return `/horde/v1/account/role?page=1&limit=50&account_type=${account_type}`;
  }

  getRoleWithDivision(account_type: string, division_id: number): string {
    const accountType = account_type.split("_");
    if (accountType.length > 1) {
      return `/horde/v1/account/role?page=1&limit=50&account_type=${accountType[0]}&division_id=${division_id}&account_role_client_type=${accountType[1]}`;
    }
    return `/horde/v1/account/role?page=1&limit=50&account_type=${account_type}&division_id=${division_id}`;
  }

  addUser(): string {
    return `/horde/v1/account`;
  }

  getListVendor(
    search: string,
    status: string,
    page: number,
    limit: number
  ): string {
    return `/horde/v1/vendor?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&status=${status}`;
  }

  getDetailVendor(id: number): string {
    return `/horde/v1/vendor/${id}`;
  }

  editVendor(): string {
    return "/horde/v1/vendor";
  }

  getCommodityList(params: RequestListCommodity): string {
    return `/horde/${params.version}/commodity?${params.toQueryString()}`;
  }

  getCommodityCategory(countryCode = ""): string {
    const params = countryCode ? `country_code=${countryCode}` : "";
    return `/horde/v1/commodity/category?${params}`;
  }

  getDetailCommodity(id: number): string {
    return `/horde/${isUrlUpdateVersion("commodity")}/commodity/${id}`;
  }

  editCommodity(): string {
    return "/horde/v1/commodity";
  }

  // embargo
  getEmbargo(page: number, limit: number, search: string, status: string) {
    return `/horde/v1/embargo?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&status=${status}`;
  }
  getDetailEmbargo(id: number): string {
    return `/horde/v1/embargo/${id}`;
  }
  addEmbargo(): string {
    return "/horde/v1/embargo";
  }
  editEmbargo(): string {
    return "/horde/v1/embargo";
  }
  stopEmbargo(id: number): string {
    return `/horde/v1/embargo/stop/${id}`;
  }
  checkEmbargo(): string {
    return "/horde/v1/embargo/check";
  }

  getLocationSearchList(
    page: number,
    limit: number,
    search: string,
    countryCode = ""
  ) {
    return `horde/v1/location?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}${countryCode ? `&country_code=${countryCode}` : ""}`;
  }

  getListLeg(
    page: number,
    limit: number,
    status: string,
    originId: string,
    destinationId: string,
    sortBy: string
  ) {
    return `/horde/v1/leg?page=${page}&limit=${limit}&status=${status}&origin_id=${originId}&destination_id=${destinationId}&sort_by=${sortBy}`;
  }

  getRoute(
    page: number,
    limit: number,
    status: string,
    originId: string,
    destinationId: string,
    sortBy: string
  ) {
    return `/horde/v1/route?page=${page}&limit=${limit}&status=${status}&origin_id=${originId}&destination_id=${destinationId}&sort_by=${sortBy}`;
  }

  getListRouteLeg(params: RequestListRouteLeg) {
    return `/horde/v2/route/leg?${params.toQueryString()}`;
  }

  getDetailRoute(id: number): string {
    return `/horde/v1/route/detail/${id}`;
  }

  getDetailLeg(id: number): string {
    return `/horde/v1/leg/${id}`;
  }

  editRoute(): string {
    return "/horde/v1/route";
  }

  getListTransport(
    search: string,
    type: string,
    status: string,
    page: number,
    limit: number
  ) {
    return `/horde/v1/transport?search=${encodeURIComponent(
      search
    )}&type=${type}&status=${status}&page=${page}&limit=${limit}`;
  }

  editLeg(): string {
    return "/horde/v1/leg";
  }

  getTransportDetail(id: number): string {
    return `/horde/v1/transport/${id}`;
  }

  editTransport(): string {
    return "/horde/v1/transport";
  }

  getListBalanceLimit(page: number, limit: number): string {
    return `/horde/v1/limit?page=${page}&limit=${limit}`;
  }

  getDetailBalanceLimit(id: number): string {
    return `/horde/v1/limit/${id}`;
  }

  getDetailBulk(id: number): string {
    return `/horde/v1/bulk/${id}`;
  }

  editBalanceLimit(): string {
    return `/horde/v1/limit`;
  }

  getVersionName(search: string) {
    return `/horde/v1/bulk/version?search=${encodeURIComponent(
      search
    )}&page=&limit=10&sort_by=asc`;
  }

  getListConfigPrice(page: number, search: string, status: string) {
    return `/horde/v2/configurable?page=${page}&limit=10&search=${encodeURIComponent(
      search
    )}&status=${status}&sort_by=ASC`;
  }

  getInsurance(params: ApiRequestList): string {
    const goodsPrice = !params.goodsPrice ? `&goods_price=${params.goodsPrice}` : ""
    return `/horde/v1/insurance?${params.toQueryString()}${goodsPrice}`
  }

  getDetailInsurance(id: number) {
    return `/horde/v1/configurable/insurance/${id}`;
  }

  addBulkUploadRetailPrice() {
    return `/horde/v1/bulk/xlsx`;
  }

  getDetailConfigWoodpacking(id: number) {
    return `/horde/v1/configurable/woodpacking/${id}`;
  }

  getDetailHeavyWeightSurcharge(id: number) {
    return `/horde/v2/configurable/heavy_weight_surcharge/${id}`;
  }

  editConfigWoodpacking() {
    return `/horde/v1/configurable`;
  }

  editConfigurablePrice(version = "v1"): string {
    return `/horde/${version}/configurable`;
  }

  getDetailRTSHQ(id: number): string {
    return `/horde/v1/configurable/penalty_rtshq/${id}`;
  }

  getGoodsTaxList(
    cityCode: string,
    status: string,
    page: number,
    limit: number,
    commodityCode: string
  ) {
    return `/horde/v1/goods_tax?page=${page}&limit=${limit}&origin_city_code=${cityCode}&status=${status}&commodity_code=${commodityCode}`;
  }

  getDetailGoodsTax(id: number) {
    return `/horde/v1/goods_tax/${id}`;
  }

  addGoodsTax(): string {
    return `/horde/v1/goods_tax`;
  }

  editGoodsTax(): string {
    return `/horde/v1/goods_tax`;
  }

  getCommoditySurchargeList(
    search: string,
    status: string,
    page: number,
    limit: number
  ) {
    return `/horde/v1/commodity_surcharge?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&status=${status}&sort_by=ASC`;
  }

  getDetailCommoditySurcharge(id: number) {
    return `/horde/v1/commodity_surcharge/${id}`;
  }

  addCommoditySurcharge(): string {
    return "/horde/v1/commodity_surcharge";
  }

  getListBaseRates(
    search: string,
    status: string,
    page: number,
    limit: number
  ) {
    return `/horde/v1/rates?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&status=${status}`;
  }

  getListRates(params: ListRatesApiRequest) {
    return `/horde/v1/rates/name?${params.toQueryString()}`;
  }

  getDetailRates(id: number) {
    return `/horde/v1/rates/${id}`;
  }

  editBaseRates(id: number): string {
    return `/horde/v1/rates/${id}`;
  }

  getListExchangeRate(
    from: string,
    to: string,
    status: string,
    page: number,
    limit: number
  ) {
    return `/horde/v1/exchange_rate?page=${page}&limit=${limit}&from=${from}&to=${to}&status=${status}`;
  }

  getDetailExchangeRate(id: number) {
    return `/horde/v1/exchange_rate/${id}`;
  }

  deactivateExchangeRate(id: number) {
    return `/horde/v1/exchange_rate/${id}/deactivate`;
  }

  // GENESIS-19589 — Est. CIPL exchange rate: single active pair, no page/limit
  getActiveExchangeRate(from: string, to: string) {
    return `/horde/v1/exchange_rate?from=${encodeURIComponent(
      from
    )}&to=${encodeURIComponent(to)}&status=active`;
  }

  getClient(
    page: number,
    limit: number,
    search: string,
    status: string,
    clientParentId?: number
  ) {
    return `/horde/v1/client?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&status=${status}${
      clientParentId ? `&client_parent_id=${clientParentId}` : ""
    }`;
  }

  getListClientRegistration(
    page: number,
    limit: number,
    search: string,
    status: string,
    type: string,
    isTotalData: boolean,
    orderBy = "",
    sortDirection = ""
  ) {
    return `/horde/v1/client/registration?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&status=${status}&type=${type}&is_total_data=${isTotalData}&order_by=${orderBy}&sort_by=${sortDirection}`;
  }

  getClientRegistrationDetail(id: number) {
    return `/horde/v1/client/registration/${id}`;
  }

  getClientRegistrationDetailV2(id: number) {
    return `/horde/v2/client/registration/${id}`;
  }

  editClientRegistration() {
    return `/horde/v1/client/resubmit`;
  }

  editClientRegistrationV2() {
    return `/horde/v2/client/resubmit`;
  }

  editClientManagemetBasic(version = "v1") {
    return `/horde/${version}/client`;
  }

  addNewExchangeRate() {
    return `/horde/v1/exchange_rate`;
  }

  getListAnnouncement(params: RequestListAnnouncement) {
    return `/horde/${isUrlUpdateVersion(
      "announcement"
    )}/announcement?${params.toQueryString()}`;
  }

  getAnnouncementDetail(id: number) {
    return `/horde/${isUrlUpdateVersion("announcement")}/announcement/${id}`;
  }

  addAnnouncement() {
    return `/horde/v1/announcement`;
  }

  deleteAnnouncement(id: number) {
    return `/horde/v1/announcement/${id}`;
  }

  addClientRegistration(version = "v1") {
    return `/horde/${version}/client`;
  }

  editClientInsuranceRate() {
    return `/horde/v1/client/rate/insurance`;
  }

  abortUploadRate() {
    return "/horde/v1/client/rate/abort";
  }

  getClientRateHistory(params: ClientRateHistoryApiRequest) {
    return `/horde/v1/client/rate/history?${params.toQueryString()}`;
  }
  createClientBranch() {
    return `/horde/v1/client/branch`;
  }

  getManagingCountry() {
    return `/horde/v1/client/managing-country`;
  }

  getListClientManagement(
    page: number,
    limit: number,
  search: string,
    searchCode: string,
    statusRates: string,
    statusClient: string,
    type: string,
    isTotalData: boolean,
    orderBy = "",
    sortDirection = ""
  ) {
    return `/horde/v1/client/management?search=${encodeURIComponent(
      search
    )}&search_code=${encodeURIComponent(
      searchCode
    )}&status_rates=${statusRates}&status_client=${statusClient}&page=${page}&limit=${limit}&type=${type}&is_total_data=${isTotalData}&order_by=${orderBy}&sort_by=${sortDirection}`;
  }

  getClientManagementDetail(id: number) {
    return `/horde/v1/client/management/${id}`;
  }

  getClientManagementDetailV2(id: number) {
    return `/horde/v2/client/management/${id}`;
  }

  editRenewRateClientManagement() {
    return "/horde/v1/client/management/renew-rate";
  }

  updateClientPeriod(id: number) {
    return `/horde/v1/client/client-rates/${id}/period`;
  }

  editRenewRateClientManagementV2() {
    return "/horde/v2/client/management/renew-rate";
  }

  updateCurrentRates(): string {
    return "horde/v1/client/management/update-live-rate";
  }

  editCurrentRatePeriode() {
    return `/horde/v1/client/period`;
  }

  approveClientRegistration() {
    return `horde/v1/client/approve`;
  }

  rejectClientRegistration() {
    return `horde/v1/client/reject`;
  }

  getListManualSTT(params: RequestListManualStt) {
    return `/hydra/${isUrlUpdateVersion(
      "sttManual",
      "v" + params.version
    )}/stt_manual?${params.toQueryString()}`;
  }

  addGenerateManualSTT() {
    return `/hydra/v1/stt_manual`;
  }

  addRenewRates() {
    return `horde/v1/client/management/renew-rate`;
  }

  addRenewRatesV2() {
    return `horde/v2/client/management/renew-rate`;
  }

  getListClientPartner(
    page: number,
    limit: number,
    search: string,
    partnerType: string,
    type: string = "",
    isBranch: boolean = false,
    isParent: boolean = false,
    orderBy: string = "",
    sortBy: string = "",
    countryCode: string = ""
  ) {
    return `/horde/v1/partner/client?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&partner_type=${partnerType}&type=${type}&is_branch=${isBranch}&is_parent=${isParent}&order_by=${orderBy}&sort_by=${sortBy}${
      countryCode ? `&country_code=${countryCode}` : ""
    }`;
  }
  getListClientParent() {
    return `/horde/v1/cargo-configuration/list-client-parent`;
  }
  getListClientMapping(params: RequestApiClientMappingList): string {
    return `/horde/v1/client/name?search=${encodeURIComponent(
      params.search
    )}&limit=${params.limit}&page=${params.page}&is_branch=${
      params.isBranch
    }&is_parent=${params.isParent}`;
  }

  approveRenewRates() {
    return `horde/v1/client/management/renew-rate/approve`;
  }

  rejectRenewRates() {
    return `horde/v1/client/management/renew-rate/reject`;
  }

  approveLiveRates() {
    return `horde/v1/client/management/live-rate/approve`;
  }

  rejectLiveRates() {
    return `horde/v1/client/management/live-rate/reject`;
  }

  getListTariff(params: CheckTariffRequest, cache: boolean) {
    return `/horde/v1/tariff?cache=${cache}&${params.toQueryString()}`;
  }

  getListCustomer(search: string, cache: boolean, refId: number = 0, refType: string = "", page: number = 1, phoneNumber: string = "") {
    return `/horde/${isUrlUpdateVersion(
      "customer"
    )}/customer?cache=${cache}&search=${encodeURIComponent(search)}&account_ref_id=${refId}&account_ref_type=${refType}&page=${page}&phone_number=${phoneNumber}`;
  }

  addCustomer() {
    return `/horde/v1/customer`;
  }

  getCustomerSavedPackage(customerId: number) {
    return `/horde/v1/customer/${customerId}/saved-package`;
  }

  getCustomerSavedPackageDetail(customerId: number, packageId: number) {
    return `/horde/v1/customer/${customerId}/saved-package/${packageId}`;
  }

  getBookingList(params: RequestListBooking) {
    return `/hydra/v${params.version}/stt?${params.toQueryString()}`;
  }
  getBookingListCBP(params: RequestListBooking) {
    return `/hydra/v1/cbp/pickup?${params.toQueryString()}`;
  }

  getManifestCBP(params: RequestListBooking) {
    return `/hydra/v1/cbp/pickup/manifest?${params.toQueryString()}`;
  }

  getBookingDetail(id: number, isWithEligibility: boolean, isAuth: boolean, pageType: string, customStatus?: string) {
    return `/hydra/v1/stt/${id}?is_with_eligibility=${isWithEligibility}&is_auth=${isAuth}&page_type=${pageType}&custom_status=${customStatus}`;
  }

  getBookingDetailByStt(params: SttDetailRequest) {
    return `/hydra/v2/stt/${params.customSuffix}${params.sttNo}?${params.toQueryString()}`;
  }

  getSttDetail(params: SttDetailRequest) {
    return `/hydra/v2/stt/me/${params.sttNo}?${params.toQueryString()}`;
  }

  getRefreshES() {
    return "/horde/v1/city/refresh_es";
  }
  addManualBooking() {
    return `/hydra/v1/stt/manual`;
  }

  getEstimationPrice(version: string): string {
    return `/horde/v${version}/tariff/estimation`;
  }

  downloadTariff(commodity_id: string | number, product_type: string) {
    return `/horde/v2/tariff/download?commodity_id=${commodity_id}&product_type=${product_type}`;
  }

  getPrintData(stt: number, accountType: string) {
    return `hydra/v1/stt/resi/${stt}?account_type=${accountType}`;
  }

  getPrintDataByStt(params: PrintDetailRequest) {
    return `hydra/v2/stt/resi/${params.bulkSuffix}${params.sttNo}?${params.toQueryString()}`;
  }

  getListStt(
    page: number,
    limit: number,
    destination_city_id: number | string,
    user_type: string,
    booked_by: string | number,
    from_date: string,
    end_date: string,
    stt_number: string,
    booked_type: string
  ) {
    return `hydra/v1/stt/manifest?page=${page}&limit=${limit}&destination_city_id=${destination_city_id ||
      ""}&user_type=${user_type}&booked_by=${booked_by}&from_date=${from_date}&end_date=${end_date}&booked_type=${booked_type}&stt_number=${stt_number}`;
  }

  getListBaggingBulkPrint(bagNumber: string) {
    return `hydra/v1/stt/manifest-bag?bag_number=${bagNumber}`;
  }

  getPartnerOptions(
    page: number,
    limit: number,
    search: string,
    type?: string
  ) {
    return `/horde/v1/partner?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&type=${type}`;
  }

  getClientOptions(
    page: number,
    limit: number,
    search: string,
    isParent: boolean
  ) {
    return `/horde/v1/client/name?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&is_parent=${isParent}`;
  }

  getCustomerOptions(page: number, limit: number, search: string) {
    return `/horde/${isUrlUpdateVersion(
      "customer"
    )}/customer?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}`;
  }

  getShipmentIdList(id: string, limit: number, page: number, isKulioner: boolean) {
    return `/hydra/v1/stt/shipment-algo/${id}?limit=${limit}&page=${page}&is_kulioner=${isKulioner}`;
  }

  getFieldShipmentBooking(shipmentNo: string) {
    return `/hydra/v1/stt/shipment/booking/field?shipment_no=${shipmentNo}`;
  }

  addShipmentBooking(version = 1) {
    return `/hydra/v${version}/stt/shipment`;
  }

  createShipmentInstantBookingDirectly() {
    return `/hydra/v2/stt/shipment/scan-book`;
  }

  exportSttManifests(
    destination_city_id: number | string,
    user_type: string,
    booked_by: string | number,
    from_date: string,
    end_date: string,
    stt_number: string,
    booked_type: string
  ) {
    return `hydra/v1/stt/manifest/export?destination_city_id=${destination_city_id}&user_type=${user_type}&booked_by=${booked_by}&from_date=${from_date}&end_date=${end_date}&booked_type=${booked_type}&stt_number=${stt_number}`;
  }

  getDrivers(isDriverExtIdNotEmpty: boolean) {
    return `/horde/v1/driver?is_driver_ext_id_not_empty=${isDriverExtIdNotEmpty}`;
  }

  addDriver(): string {
    return `/horde/v1/driver`;
  }

  getVehicles(search: string) {
    return `/horde/v1/vehicle?search=${encodeURIComponent(search)}`;
  }

  getPickupManifestList(
    page: number,
    limit: number,
    startDate: string,
    endDate: string
  ) {
    return `/hydra/v1/pickup/manifest?page=${page}&limit=${limit}&pickup_start_date=${startDate}&pickup_end_date=${endDate}`;
  }

  createNewVehicle() {
    return `/horde/v1/vehicle`;
  }

  getSttListSttChecklist(
    page: number,
    limit: number,
    status: string,
    date: string,
    sortBy: string,
    productType: string,
    cache: boolean
  ) {
    return `/hydra/v1/stt/manifest/checklist?cache=${cache}&page=${page}&limit=${limit}&status=${status}&date=${date}&sort_by=${sortBy}&product_type=${productType}`;
  }

  // STI-SC
  getStiSCList(params: RequestListSTISC) {
    return `/hydra/v1/sti/sc?${params.toQueryString()}`;
  }

  getDetailSttPiecesSTI(sttNumber: string) {
    return `/hydra/v1/sti/stt-detail?stt_or_pickup_code=${sttNumber}`;
  }

  getDetailSttPiecesSTILilo(bagNo: string) {
    return `/hydra/v2/sti/stt-detail?stt_or_pickup_code=${bagNo}`;
  }

  getDetailSttPiecesStiSc(sttNumber: string) {
    return `/hydra/v1/sti/sc/scan-detail?stt_no=${sttNumber}`;
  }

  generateStiSc(): string {
    return "/hydra/v1/sti/sc";
  }

  generateStiDestSc(): string {
    return "/hydra/v1/sti-dest/sc";
  }

  getSTISCSession(params: RequestListSTISCSession): string {
    return `/hydra/v1/sti/sc/detail-session?${params.toQueryString()}`;
  }

  createSTISCSession(): string {
    return `/hydra/v1/sti/sc/create-session`;
  }

  processUpdateSTISC(): string {
    return `/hydra/v1/sti/sc/scan`;
  }

  finishSessionSTISC(): string {
    return `/hydra/v1/sti/sc/finish-session`;
  }

  generateSti(): string {
    return "/hydra/v1/sti/generate";
  }

  postManifestSTIReverseScan() {
    return "hydra/v2/sti/manifest";
  }

  getDetailSTTPieces(sttPiece: string) {
    return `/hydra/v1/pickup/manifest/stt-detail?stt_piece=${sttPiece}`;
  }

  getSTIList(params: StiListRequest, version = "v1"): string {
    return `/hydra/${version}/sti?${params.toQueryString()}`;
  }

  downloadManifest(params: string, version = "v1"): string {
    return `/hydra/${version}/${params}`;
  }

  validationScanSTTPiece(sttPiece: string) {
    return `/hydra/v1/pickup/manifest/stt-detail/scan?stt_piece=${sttPiece}`;
  }

  validationScanSTTStiSc(sttPiece: string) {
    return `hydra/v1/sti/sc/scan?stt_piece=${sttPiece}`;
  }

  getPrintDataPickupManifest(id: number) {
    return `/hydra/v1/pickup/manifest/detail/${id}`;
  }

  updatePickupManifest(): string {
    return `/hydra/v1/pickup/manifest`;
  }

  validationScanSTISTTPiece(sttPiece: string) {
    return `/hydra/v1/sti/scan?stt_piece=${sttPiece}`;
  }

  getListBagging(params: BaggingListRequest) {
    return `/hydra/v1/bag?${params.toQueryString()}`;
  }
  getDetailBagging(id: number) {
    return `/hydra/v1/bag/detail/${id}`;
  }
  getDetailSttNumberBagging(sttNumber: string, partnerId?: number) {
    return `/hydra/v1/bag/stt-detail?bag_or_stt_no=${sttNumber}&partner_id=${partnerId ||
      ""}&hub_id=${getHubData()?.hubId || 0}`;
  }

  createBagging(): string {
    return "/hydra/v1/bag";
  }

  updateBagging(): string {
    return `/hydra/v1/bag`;
  }

  updateBaggingToRTC(): string {
    const version = FlagsPermissionBagging.permission_bagging_rtc_v2_enable.isEnabled()
      ? "v2"
      : "v1";
    return `/hydra/${version}/bag/bag-rtc`;
  }

  getRegionBaggingGrouping(code: string): string {
    return `/horde/v1/bagging_group_location/:id?bgl_destination_id=${code}`;
  }

  getBaggingDisputeSummary(params: BaggingDisputeSummaryRequest): string {
    return `/hydra/v1/bag/dispute-summary?${params.toQueryString()}`;
  }

  downloadBaggingDisputeSummary(): string {
    return `/hydra/v1/bag/dispute-download`;
  }

  getListStiDest(params: StiDestListRequest) {
    return `/hydra/${params.version}/sti-dest?${params.toQueryString()}`;
  }

  getStiDestSummary() {
    return `/hydra/v1/stt-due/sti-dest-del/summary`;
  }

  getPriorityDelSummary() {
    return `/hydra/v1/priority-delivery-management/summary`;
  }

  onValidateSttPieceStiDest(sttPiece: string) {
    return `/hydra/v1/sti-dest/scan?stt_piece=${sttPiece}`;
  }
  updateStiDest() {
    return `/hydra/v1/sti-dest`;
  }

  stiDestReverseScan() {
    return `hydra/v2/sti-dest`;
  }

  getStiDestReverseScan(params: RequestListSTIDestTemporary) {
    return `hydra/v2/sti-dest/temporary?${params.toQueryString()}`;
  }

  postManifestStiDestReverseScan() {
    return `hydra/v2/sti-dest/manifest`;
  }

  getListStiDestSc(
    page: number,
    limit: number,
    startDate: string,
    endDate: string,
    search: string
  ) {
    return `/hydra/v1/sti-dest/sc?page=${page}&limit=${limit}&start_date=${startDate}&end_date=${endDate}&search=${encodeURIComponent(
      search
    )}`;
  }

  getSummaryStiDestNeedToDel() {
    return `/hydra/v1/stt-due/sti-dest-del/summary`;
  }

  getDownloadExcelStiDestNeedToDel() {
    return `/hydra/v1/stt-due/sti-dest-del/excel`;
  }

  getListStiDestNeedToDel(params: RequestListNeedToSTIDestDel) {
    return `/hydra/v1/stt-due/sti-dest-del?${params.toQueryString()}`;
  }

  // Handover
  getHandoverList(params: RequestListHandover) {
    return `/hydra/${params.version}/handover?${params.toQueryString()}`;
  }
  getSttDetailHandover(stt: string, bagNo: string, partnerCode: string) {
    return `/hydra/v1/handover/stt-detail?stt_no=${stt}&bag_no=${bagNo}&partner_code=${partnerCode}`;
  }
  updateHandover(): string {
    return "/hydra/v1/handover";
  }
  getPartnerVendorList(params: RequestPartnerVendorList): string {
    return `/hydra/v1/handover/list-vendor-partner?${params.toQueryString()}`;
  }

  getDetailHandover(handoverId: number) {
    return `/hydra/v1/handover/${handoverId}`;
  }
  getFailedVendorSttHandover(
    handoverId: number,
    params?: { page?: number; limit?: number; isTotalData?: boolean, showOnlyFailed?: boolean }
  ) {
    const page = params?.page || 1;
    const limit = params?.limit || 100;
    const isTotalData =
      params && "isTotalData" in params ? params.isTotalData : true;
    const showOnlyFailed = 
      params && "showOnlyFailed" in params ? params.showOnlyFailed : false;
    return `/hydra/v1/handover/${handoverId}/failed-vendor-stt?page=${page}&limit=${limit}&is_total_data=${isTotalData}&show_only_failed=${showOnlyFailed}`;
  }

  getHandoverFailedStt(handoverId: number) {
    return `/hydra/v1/handover/${handoverId}/failed-stt`;
  }

  retryHandoverVendorOrder(handoverId: number) {
    return `/hydra/v1/handover/${handoverId}/retry`;
  }

  getListSubconsole(parentId: number) {
    return `/horde/v1/partner?parent_id=${parentId}&type=sub-console&use_location=false&limit=10&page=1`;
  }

  getStiSCManifestDetail(id: number) {
    return `/hydra/v1/sti/sc/detail/${id}`;
  }

  getPrintDataSTIDestSC(id: number) {
    return `/hydra/v1/sti-dest/sc/detail/${id}`;
  }

  getStiDestManifestDetail(id: number) {
    return `/hydra/v1/sti-dest/detail/${id}`;
  }

  cancelBooking(): string {
    return `/hydra/v1/stt/cancel`;
  }

  editBooking(id: number): string {
    return `/hydra/v1/stt/${id}`;
  }

  getStiManifestData(id: number, version = "v1") {
    return `/hydra/${version}/sti/pdf/${id}`;
  }

  getDetailPickupStt(sttNumber: string) {
    return `/hydra/v1/pickup/manifest/stt-detail?stt_no=${sttNumber}`;
  }

  getExistCustomer(name: string, phone: string, address: string) {
    return `/horde/${isUrlUpdateVersion(
      "customer"
    )}/customer/detail?name=${name}&phone=${phone}&address=${address}`;
  }

  getDetailSttStiDestSc(sttOrBagNumber: string) {
    return `/hydra/v1/sti-dest/sc/stt-detail?stt_or_bag_no=${sttOrBagNumber}`;
  }

  getStiDestSttList(bagOrStt: string) {
    return `/hydra/v1/sti-dest/stt-detail?bag_or_stt_no=${bagOrStt}`;
  }

  getStiDestSttListLilo(bagNo: string) {
    return `/hydra/v2/sti-dest/stt-detail?bag_or_stt_no=${bagNo}`;
  }

  // Shortland
  getShortlandList(
    page: number,
    limit: number,
    startDate: string,
    endDate: string,
    search: string
  ) {
    return `/hydra/v1/shortland?page=${page}&limit=${limit}&start_date=${startDate}&end_date=${endDate}&search=${encodeURIComponent(
      search
    )}`;
  }

  // POD/DEX
  getListReason(params: ReasonListDex) {
    return `/hydra/v1/reason?${params.toQueryString()}`;
  }
  getPodDexList(params: RequestListPodDex): string {
    return `/hydra/${params.version}/pod?${params.toQueryString()}`;
  }
  getPodDownload(params: ApiRequestList): string {
    return `hydra/v1/pod/download?${params.toQueryString()}`;
  }

  // Delivery Manifest
  getDeliveryManifest(
    page: number,
    limit: number,
    startDate: string,
    endDate: string,
    search: string
  ) {
    return `/hydra/v1/delivery_manifest?page=${page}&limit=${limit}&start_date=${startDate}&end_date=${endDate}&search=${encodeURIComponent(
      search
    )}`;
  }

  updateDeliveryManifest() {
    return `/hydra/v1/delivery_manifest`;
  }
  getDetailDeliveryStt(sttNumber: string) {
    return `/hydra/v1/delivery_manifest/stt-detail?stt_or_bag_no=${sttNumber}`;
  }

  getDeliveryManifestPdfData(id: number) {
    return `/hydra/v1/delivery_manifest/detail/${id}`;
  }

  updatePodDex() {
    return `/hydra/v1/pod`;
  }

  getListPODRecipientRelation(isEn: boolean) {
    return `/hydra/v1/pod/relation?is_en=${isEn}`;
  }

  checkPaymentStatus() {
    return `/hydra/v1/stt/payment/status`;
  }

  getListSTTPaidUnpaidV2(params: RequestListBooking) {
    return `/hydra/v1/stt/payment?${params.toQueryString()}`;
  }

  getListPos(params: RequestListPartner): string {
    return `/horde/v1/partner?${params.toQueryString()}`;
  }

  getPartnerConsolidatorList(
    page: number,
    limit: number,
    search: string,
    contract_status: string,
    cityCode: string,
    status: string
  ): string {
    return `/horde/v1/partner?search=${encodeURIComponent(
      search
    )}&page=${page}&limit=${limit}&use_location=true&city_code=${cityCode}&type=console&is_default_location=true&contract_status=${contract_status}&status=${status}`;
  }

  getPartnerSubconsoleList(
    search: string,
    page: number,
    limit: number,
    useLocation: boolean,
    isDefaultLocation: boolean,
    cityCode: string,
    districtCode: string,
    status: string,
    contractStatus: string
  ) {
    return `/horde/v1/partner?search=${encodeURIComponent(
      search
    )}&page=${page}&limit=${limit}&use_location=${useLocation}&is_default_location=${useLocation}&city_code=${cityCode}&district_code=${districtCode}&type=sub-console&status=${status}&contract_status=${contractStatus}`;
  }

  getPartnerList(params: RequestListPartner) {
    return `/horde/${params.version}/partner?${params.toQueryString()}`;
  }
  getPartnerDetail(id: number, tieringLevel: boolean, version = "v1") {
    return `/horde/${version}/partner/${id}?is_show_tiering_level=${tieringLevel}`;
  }

  checkReferralCode(referralCode: string) {
    return `/horde/v1/partner/referral/${referralCode}`;
  }

  addPartner(type: string, version: string) {
    return `/horde/${version}/partner/${type}`;
  }

  getConsolidatorsByCity(
    search: string,
    page: number,
    limit: number,
    cityCode: string,
    type: string,
    status: string,
    countryCode = ""
  ): string {
    return `/horde/v1/partner?search=${encodeURIComponent(
      search
    )}&page=${page}&limit=${limit}&city_code=${cityCode}&type=${type}&status=${status}${
      countryCode ? `&country_code=${countryCode}` : ""
    }`;
  }

  patchPartner(type: string, version: string) {
    return `/horde/${version}/partner/${type}`;
  }

  freezeUnFreezePartner(id: number) {
    return `/horde/v1/partner/status/${id}`;
  }

  getListPartnerBank() {
    return `/horde/v1/bank`;
  }

  getClientNamePOS(
    search: string,
    page: number,
    limit: number,
    isBranch: boolean,
    isCbp = false,
    packageType = "",
    cityCode = "",
    isDirectory = false
  ): string {
    return `/horde/v1/client/name/pos?search=${encodeURIComponent(
      search
    )}&limit=${limit}&page=${page}&is_branch=${isBranch}&is_api_cbp=${isCbp}&package_type=${packageType}&city_code=${cityCode}&is_directory=${isDirectory}`;
  }

  getPosClientList(search: string, version = "v1", accountType = "") {
    return `/horde/${version}/partner/pos-client?search=${encodeURIComponent(search)}${version === 'v2' ? `&account_type=${accountType}` : ''}`;
  }

  getCustomProcessList(params: RequestListCustomProcess) {
    return `/hydra/v1/custom-process?${params.toQueryString()}`;
  }
  // Custom Process

  getDetailCustomProcess(id: number) {
    return `/hydra/v1/custom-process/detail/${id}`;
  }

  updateStatusCustomProcess(): string {
    return "/hydra/v1/custom-process";
  }

  patchReverseDestinationStt(id: any): string {
    return `/hydra/v1/stt/reverse-destination/${id}`;
  }

  getCustomProcessSttDetail(params: STTDetail): string {
    return `/hydra/v1/custom-process/stt-detail?${params.toQueryString()}`;
  }

  getReasonCustomProcess() {
    return `hydra/v1/custom-process-role/status`;
  }

  getProductsDelivery(
    search: string,
    page: number,
    limit: number,
    status: string
  ): string {
    return `/horde/v1/product?search=${encodeURIComponent(
      search
    )}&page=${page}&limit=${limit}&is_no_limit=true&status=${status}`;
  }

  getInsuranceTypesDelivery(insuranceConfig: number, originCountry?: string): string {
    const base = `/horde/v1/configurable/insurance/${insuranceConfig}`;
    return originCountry ? `${base}?origin_country=${originCountry}` : base;
  }

  validateSttManual(
    clientId: number,
    sttManual: string,
    bookingType: string,
    productType: string
  ) {
    return `/hydra/v1/stt_manual/validate?client_id=${clientId}&stt_manual=${sttManual}&booking_type=${bookingType}&product_type=${productType}`;
  }

  validateSttReferenceExt(
    validateType: string,
    noRefExternal: string,
    shipmentId = "",
    clientCode = ""
  ) {
    if (validateType === "shipment_id") {
      return `/hydra/v1/stt/validate?validate_type=${validateType}&shipment_id=${shipmentId}&client_code=${clientCode}`;
    }
    return `/hydra/v1/stt/validate?validate_type=${validateType}&no_ref_external=${noRefExternal}`;
  }

  getAdjustmentStt(
    sttNo: string
  ) {
    return `/hydra/v1/stt/adjustment/field?stt_no=${sttNo}`;
  }

  addBookingCorporate() {
    return `/hydra/v1/stt/corporate`;
  }

  // Bulk Booking
  validateBookingPhone() {
    return `/hydra/v1/stt/validate/phone`;
  }
  getSuccessListBooked(id: number) {
    return `/horde/v1/bulk/stt/${id}`;
  }

  downloadFailedFileBulkBooking(id: number) {
    return `/horde/v1/bulk/error/${id}`;
  }
  getListBulkBooking(params: RequestBulkBooking) {
    return `/horde/v${params.version}/bulk?${params.toQueryString()}`;
  }

  getDetailRepairBulk(params: RequestDetailRepairBulkBooking) {
    return `/horde/v1/bulk/stt/${params.id}/repair?last_row_num=${params.lastRowNum}`
  }

  getListBulkBookingResi(id: number) {
    return `/horde/v1/bulk/resi/${id}`;
  }

  downloadSuccessBulkBooking(id: number): string {
    return `/horde/v1/bulk/${id}/success`;
  }

  downloadFailedBulkBooking(id: number): string {
    return `/horde/v1/bulk/${id}/error`;
  }

  getDetailRefundConfiguration(id: number) {
    return `/horde/v1/configurable/refund/${id}`;
  }
  getDetailAdjustmentPenalty(id: number) {
    return `/horde/v1/configurable/stt_adjustment/${id}`;
  }

  getListBankAccount(page: number, limit: number, type: string) {
    return `/gober/v1/bank_account?limit=${limit}&page=${page}&bank_account_type=${type}`;
  }

  getListInternalBankAccount() {
    return `/gober/v1/bank_account/internal/list-detail-bank`;
  }

  getDetailInternalBankAccount(id: number) {
    return `/gober/v1/bank_account/internal/detail-bank?bank_id=${id}`;
  }

  getDetailTopupManual(id: number) {
    return `/gober/v1/topup_manual/${id}`;
  }

  addTopupManual() {
    return `/gober/v1/topup_manual`;
  }

  approveTopupApproval() {
    return `/gober/v1/topup_manual/approve`;
  }

  rejectTopupApproval() {
    return `/gober/v1/topup_manual/reject`;
  }

  getListTransaction(params: GetListBalanceApiRequest, apiVersion: string) {
    return `/gober/${apiVersion}/transaction?${params.toQueryString()}`;
  }

  getTrackingStt(sttNo: string, cache: boolean, version: string, isEn: boolean) {
    const params = {
      cache,
      q: sttNo,
      type: IS_SENDER_ACCOUNT ? "external" : "",
      is_en: isEn
    };
    return `/hydra/${version}/stt/tracking?${
      new QueryParamsEntities2(params).queryString
    }`;
  }

  getTrackingSttTokopedia(sttNo: string) {
    const params = {
      q: sttNo,
    };
    return `/hydra/v2/stt/tracking/tokopedia?${
      new QueryParamsEntities2(params).queryString
    }`;
  }

  getTrackingCargo(cargoNo: string) {
    return `/hydra/v1/cargo?cargo_no=${cargoNo}`;
  }

  getCargoCommodityList(page: number, limit: number, search: string) {
    return `/horde/v1/commodity/group?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}`;
  }

  getSearchCargoOptions(origin: string, destination: string) {
    return `/horde/v1/leg/transport-type?origin=${origin}&destination=${destination}`;
  }

  createCargo() {
    return `/hydra/v5/cargo`;
  }

  createCargoV3() {
    return `/hydra/v3/cargo`;
  }

  updateRetryCargo(id: number, version: string) {
    return `/hydra/${version}/retry_cargo/${id}`;
  }

  getActiveCashback(id: any) {
    return `/horde/v1/configurable-cashback/active-retail/${id}`;
  }

  cashbackConfigList(params: CashbackListRequest) {
    return `/horde/v1/configurable-cashback?${params.toQueryString()}`;
  }

  cashbackConfigCreate() {
    return `/horde/v1/configurable-cashback`;
  }

  cashbackConfig(id: any) {
    return `/horde/v1/configurable-cashback/${id}`;
  }

  // Algo
  loginAlgo() {
    return `/v1/account/auth/login`;
  }

  getPosFavoriteSubscriberList(
    agentCode: string,
    phoneNumber: string,
    page: number,
    limit: number
  ) {
    return `/v1/shipment/elexys/agent/favorite/customer?agent_code=${agentCode}&phone_number=${phoneNumber}&page=${page}&per_page=${limit}`;
  }

  editMemberDiscount() {
    return `/v1/shipment/elexys/agent/favorite/customer/discount`;
  }
  getPosFavoriteSubscriberOutstandingList(
    agentCode: string,
    phoneNumber: string,
    page: number,
    limit: number,
    status: string
  ) {
    return `/v1/shipment/elexys/agent/favorite/invoice?agent_code=${agentCode}&phone_number=${phoneNumber}&page=${page}&per_page=${limit}&status=${status}`;
  }

  getBalance(cache: boolean) {
    return IS_SENDER_ACCOUNT
      ? "/phoenix/v1/account/balance"
      : `/gober/v1/wallet/detail?cache=${cache}`;
  }

  getListLastBalance(params: RequestListLastBalance) {
    return `/gober/v1/wallet/last-balance?${params.toQueryString()}`;
  }

  downloadLastBalance(params: LastBalanceDownloadRequest) {
    return `/gober/v1/report/download/last_balance?${params.toQueryString()}`;
  }
  getListLastBalanceV2(params: RequestListLastBalanceV2) {
    return `/gober/v2/wallet/last-balance?${params.toQueryString()}`;
  }

  editDefaultDiscount() {
    return `/v1/shipment/elexys/agent/discount`;
  }

  // COD Income
  getListCodIncome(
    page: number,
    limit: number,
    type: string,
    startDate: string,
    endDate: string,
    search: string
  ): string {
    const suffix = `${FlagsPermissionCodBalanceSwitchToFcs.permission_cod_balance_switch.isEnabled() ? '/client' : ''}`;
    return `/gober/v1/cod${suffix}?page=${page}&limit=${limit}&trx_type=${type}&start_date=${startDate}&end_date=${endDate}&search=${encodeURIComponent(
      search
    )}`;
  }
  getExportCodTransaction(
    page: number,
    type: string,
    startDate: string,
    endDate: string
  ) {
    const suffix = `${FlagsPermissionCodBalanceSwitchToFcs.permission_cod_balance_export_switch.isEnabled() ? '/client' : ''}`;
    return `/gober/v1/cod${suffix}/export?page=${page}&trx_type=${type}&start_date=${startDate}&end_date=${endDate}`;
  }

  // Cargo
  getListCargo(params: CargoListRequest): string {
    return `hydra/v1/cargo/list?${params.toQueryString()}`;
  }
  getListRetryCargo(params: CargoListRequest): string {
    return `hydra/v1/retry_cargo?${params.toQueryString()}`;
  }
  getDetailCargo(id: string | number): string {
    return `/hydra/v1/cargo/detail/${id}?activity=`;
  }
  getDetailCargoByCargoNo(cargoNo: string): string {
    return `/hydra/v1/cargo/detail-cargo-stt?cargo_no=${encodeURIComponent(
      cargoNo
    )}`;
  }
  getLastIdCargo(params: CargoListRequest) {
    return `/hydra/v1/cargo/last-id?${params.toQueryString()}`;
  }
  downloadListCargoSuccess() {
    return "/hydra/v1/cargo/download-success";
  }

  getDetailRetryCargo(rcNo: string,  version?: string): string {
    return `/hydra/${version || "v1"}/retry_cargo/detail/${encodeURIComponent(rcNo)}`;
  }

  getDetailDefaultDiscount(agentCode: string) {
    return `/v1/shipment/elexys/agent/${agentCode}/discount`;
  }
  editCargo() {
    return `/hydra/v1/cargo`;
  }
  searchFlight(): string {
    return `hydra/v1/cargo/search-flight`;
  }
  checkAvailableNGen(): string {
    return `hydra/v1/cargo/validate-flight`;
  }
  calculateVolume(): string {
    return "hydra/v1/cargo/calculate";
  }
  getCargoDisputeSummary(params: CargoListRequest): string {
    return `hydra/v1/cargo/dispute-summary?${params.toQueryString()}`;
  }
  downloadExcelCargoDisputeSummary(): string {
    return `/hydra/v1/cargo/dispute-download`;
  }
  getCargoSuccessSummary(params: CargoListRequest): string {
    return `hydra/v1/cargo/success-summary?${params.toQueryString()}`;
  }
  getCargoFailedUnread(params: FailedUnreadRequest): string {
    return `hydra/v1/cargo/failed-unread?${params.toQueryString()}`;
  }

  // dashboard
  getDashboardConsole(params: DashboardConsoleRequest): string {
    return `/hydra/v2/dashboard?${params.toQueryString()}`;
  }

  getSummaryCodCourierPartner(type = "POS", date: any, version: string): string {
    return `/hydra/${version}/dashboard-delivery/courier/summary?type=${type}&filter_date=${date}&hub_id=${getHubData()?.hubId || 0}`;
  }
  getCutOffConsoleOutgoingStt(): string {
    return "/hydra/v2/dashboard/cut_off";
  }
  getDashboardDelivery(path = "", queryString = "", version = "v1"): string {
    return `/hydra/${version}/dashboard-delivery${path}?${queryString}`;
  }
  getCorporateDashboard(path = "", queryString = ""): string {
    return `/hydra/v1/corporate-dashboard${path}?${queryString}`;
  }
  getSenderDashboard(path = "", queryString = ""): string {
    return `/phoenix/v1/sender-dashboard${path}?${queryString}`;
  }
  getPosPerformanceDashboard(path = "", queryString = ""): string {
    return `/hydra/v1/pos-dashboard${path}?${queryString}`;
  }

  getPosFollowUpList(params: RequestList) {
    return `/hydra/v2/dashboard/pos/cut_off?${params.toQueryString()}`;
  }

  getPerformanceEmbed(): string {
    return "/hydra/v1/dashboard/performance/embed";
  }

  getDashboardDetailList(params: DashboardDetailListRequest) {
    const { tab: path } = params;
    delete params.tab;
    const endpoint = path === "current-stt" ? "/cut_off" : path || "";
    return `/hydra/v2/dashboard/detail${endpoint}?${params.toQueryString()}`;
  }

  getDownloadDashboard(params: DashboardDownloadRequest) {
    const { tab: path } = params;
    delete params.tab;
    return `/hydra/v2/dashboard/download${
      path === "current-stt" ? "/cut_off" : ""
    }?${params.toQueryString()}`;
  }

  getDownloadPOSDashboard(params: DashboardDetailListRequest) {
    return `/hydra/v2/dashboard/download/pos/cut_off?${params.toQueryString()}`;
  }

  getBeneficiaryAccList(
    page: number,
    limit: number,
    bankAccType: string,
    actortype: string,
    actorId: number
  ) {
    return `/gober/v1/bank_account?limit=${limit}&page=${page}&bank_account_type=${bankAccType}&actor_type=${actortype}&actor_id=${actorId}`;
  }

  validateBankAccount() {
    return `/gober/v1/bank_account/validate`;
  }

  getOnProcessSttList(params: RequestListOnProcessStt) {
    return `/hydra/v${params.version}/on-process?${params.toQueryString()}`;
  }

  getCargoProductList(status: string) {
    return `/horde/v1/cargo-product?status=${status}`;
  }

  appendBagOrSttNumber() {
    return `/hydra/v1/cargo/scan`;
  }

  getDetailManualDeductAddSaldo(id: number) {
    return `/gober/v1/saldo_adjustment/detail/${id}`;
  }

  getListOfActors(search: string) {
    return `/gober/v1/saldo_adjustment/actor_created?search=${encodeURIComponent(
      search
    )}&page=1&limit=10`;
  }

  getListAirport(
    airportCode: string,
    cityCode: string,
    page: number,
    limit: number,
    isLocation?: boolean,
    search?: string
  ): string {
    return `/horde/v1/airport?airport_code=${airportCode}&city_code=${cityCode}&page=${page}&limit=${limit}&is_location=${isLocation ||
      false}&search=${search || ""}`;
  }

  getDetailAirport(airportCode: string): string {
    return `/horde/v1/airport/detail?airport_code=${airportCode}`;
  }

  getAirportRouteType(): string {
    return `/horde/v1/airport/route-type`;
  }

  getListShipmentPrefix() {
    return `/hydra/v1/stt/shipment/prefix`;
  }

  validateShipmentId() {
    return "/hydra/v1/stt/shipment-validate";
  }

  getBookingCommissionDetail(id: number) {
    return `/horde/v1/booking_commission/detail/${id}`;
  }

  bookingCommissionEndpoint() {
    return `/horde/v2/booking_commission`;
  }

  // bulk booking commission
  createBulkBookingCommission() {
    return `/horde/v2/booking_commission/bulk`;
  }

  getBookingCommissionList(params: RequestBookingCommissionList): string {
    return `/horde/v${
      params.version
    }/booking_commission?${params.toQueryString()}`;
  }

  getBulkBookingCommissionList(
    page: number,
    limit: number,
    search: string,
    status: string
  ): string {
    return `/horde/v1/booking_commission/bulk?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&status=${status}`;
  }

  getTopUpVerificationDetail(id: number) {
    return `/gober/v1/topup_manual/${id}`;
  }

  getBulkBookingCommissionDetail(id: number) {
    return `/horde/v1/booking_commission/bulk/detail/${id}`;
  }

  createDeductSaldo() {
    return `/gober/v1/saldo_adjustment`;
  }

  getManualDeductAddSaldoList(
    page: number,
    limit: number,
    search: string,
    actorType: string,
    actorId: number,
    startDate: string,
    endDate: string,
    type: string,
    createdBy: string
  ): string {
    return `/gober/v1/saldo_adjustment?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&adjustment_type=${type}&actor_type=${actorType}&actor_id=${actorId}&start_date=${startDate}&end_date=${endDate}&created_by=${createdBy}`;
  }

  getDeductReports(
    adjustmentType: string,
    actorType: string,
    actorId: number,
    startDate: string,
    endDate: string,
    createdBy: number
  ): string {
    return `/gober/v1/saldo_adjustment/export?adjustment_type=${adjustmentType}&actor_type=${actorType}&actor_id=${actorId}&start_date=${startDate}&end_date=${endDate}&created_by=${createdBy}`;
  }

  getListTopupApproval(
    page: number,
    limit: number,
    search: string,
    partnerName: string,
    status: string,
    bankName: string,
    verifiedBy: string
  ) {
    return `/gober/v1/topup_manual/list-history?limit=${limit}&page=${page}&partner_name=${partnerName}&bank_name=${bankName}&verified_by=${verifiedBy}&id&status=${status}&search=${encodeURIComponent(
      search
    )}&menu=approved`;
  }

  getTransactionHistoryList(
    page: number,
    limit: number,
    status: string,
    startDate: string,
    endDate: string
  ): string {
    return `/gober/v1/topup_manual/list-history?status=${status}&limit=${limit}&page=${page}&start_date=${startDate}&end_date=${endDate}`;
  }

  getActorVerifiedList(): string {
    return "/gober/v1/topup_manual/list-actor/verified";
  }

  getTopupApprovalDetail(id: number): string {
    return `/gober/v1/topup_manual/${id}`;
  }

  getTopUpVerificationList(
    page: number,
    limit: number,
    search: string,
    partner: string,
    status: string,
    bank: string,
    verifiedBy: string
  ) {
    return `/gober/v1/topup_manual/list-history?limit=${limit}&page=${page}&partner_name=${partner}&bank_name=${bank}&verified_by=${verifiedBy}&search=${encodeURIComponent(
      search
    )}&status=${status}`;
  }

  getListVerifier() {
    return `/gober/v1/topup_manual/list-actor/verified`;
  }

  verifyTopUpVerification() {
    return `/gober/v1/topup_manual/verify`;
  }

  rejectTopUpVerification() {
    return `/gober/v1/topup_manual/verification-reject`;
  }

  getExistingData(service: string, type: string) {
    return `/${service}/${type}`;
  }

  getListDeliveryVendor(page: number, limit: number, search: string) {
    return `/horde/v1/delivery_vendor?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}`;
  }

  addDeliveryVendor() {
    return `/horde/v1/delivery_vendor`;
  }

  // DTPOL
  getDtpoList(page: number, limit: number, search: string): string {
    return `/horde/v1/dtpol?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}`;
  }
  getDtpolDetail(id: number): string {
    return `/horde/v1/dtpol/${id}`;
  }
  editDtpol() {
    return `/horde/v1/dtpol`;
  }

  // DEL
  getUpdateDelList(
    page: number,
    limit: number,
    search: string,
    startDate: string,
    endDate: string
  ): string {
    return `/hydra/v1/del?page=${page}&limit=${limit}&search=${encodeURIComponent(
      search
    )}&start_date=${startDate}&end_date=${endDate}`;
  }
  getSttValidationUpdateDel(sttNo: string) {
    return `/hydra/v1/del/stt-detail?stt_no=${sttNo}&hub_id=${getHubData()?.hubId || 0}`;
  }

  createUpdateDelivery() {
    return `/hydra/v1/del`;
  }

  printDelivery(id: number) {
    return `/hydra/v1/del/${id}`;
  }

  // messaging service configuration
  getMessagingServiceConfigurationList(
    params: RequestMessagingServiceConfigurationList
  ) {
    return `/horde/v${params.version}/message?${params.toQueryString()}`;
  }

  partnerApi(params: any) {
    const query = new QueryParamsEntities(params);
    return `/horde/v1/partner?${query.queryString}`;
  }

  getMessagingServiceConfigurationDetail(id: number) {
    return `/horde/v1/message/${id}`;
  }

  createMessagingConfig() {
    return `/horde/v1/message`;
  }

  clientManagementApi(params: any) {
    const query = new QueryParamsEntities(params);
    return `/horde/v1/client/management?${query.queryString}`;
  }

  getMessagingDictionary() {
    return `/horde/v1/message/dictionary`;
  }

  templateWhatsappPremiumApi(params: any) {
    const query = new QueryParamsEntities(params);
    return `/horde/v1/message_wa_premium?${query.queryString}`;
  }

  withdrawBalance(version = "v1") {
    return `/gober/${version}/withdraw`;
  }

  // report
  getDownloadReport(params: ReportApiRequest) {
    const query = new QueryParamsEntities(params);
    return `/${params.service}/v${params.version}/${params.feature}/download/${
      params.title
    }${params.isCheck ? "/check_data" : ""}?${query.queryString}`;
  }

  getRequestDownloadReport(params: ReportApiRequest) {
    const query = new QueryParamsEntities(params);
    return `/${params.service}/v${params.version}/${params.feature}/download/${params.title}?${query.queryString}`;
  }

  getDownloadBalanceReportMutation(params: BalanceReportMutationApiRequest) {
    return `/gober/${params.apiVersion}/report/download/mutation?activity=${params.activity}&start_date=${params.startDate}&end_date=${params.endDate}&transaction_type=${params.transactionType}&actor_id=${params.actorId}`;
  }

  getListDownloadReport(params: ReportListDownloadRequest) {
    return `/hydra/v2/report/bulk-download?${params.toQueryString()}`;
  }

  getClientRateBulkDownloadList() {
    return `/horde/v1/report/bulk-download`;
  }

  downloadClientRate(clientId: number) {
    return `/horde/v1/client/${clientId}/download-rate`;
  }

  // edit email account
  editEmailAccount() {
    return `/horde/v1/account/email`;
  }

  // Integration Monitoring
  getElexysFailedBookingList(
    params: RequestApiElexysFailedBookingList
  ): string {
    const query = new QueryParamsEntities(params);
    return `/hydra/v1/log-failed-stt-elexys?${query.queryString}`;
  }

  downloadElexysFailedBooking(
    params: RequestDownloadElexysFailedBooking
  ): string {
    const query = new QueryParamsEntities(params);
    return `/hydra/v1/log-failed-stt-elexys/download?${query.queryString}`;
  }

  getLogStt(sttNo: string) {
    return `/hydra/v1/partner-log?stt_no=${sttNo}`;
  }

  retryBookingElexys() {
    return `/hydra/v1/elexys/stt/booking/retry`;
  }

  getBalanceClientPartner(params: any) {
    const query = new QueryParamsEntities2(params);
    return `/gober/v1/wallet/client-partner/detail?${query.queryString}`;
  }

  freezeUnfreezeClient(status: string) {
    return `/horde/v1/client/${status}`;
  }

  retryUploadClientRate() {
    return `/horde/v1/client/retry-upload-rate`;
  }

  // KEJAR CUAN
  kejarCuanApi() {
    return `/horde/v1/kejarcuan`;
  }
  getKejarCuanConfigurationList(params: any) {
    const query = new QueryParamsEntities(params);
    return `${this.kejarCuanApi()}?${query.queryString}`;
  }
  getKejarCuanConfigurationDetail(id: number) {
    return `${this.kejarCuanApi()}/${id}`;
  }
  getKejarCuanProgress() {
    return `${this.kejarCuanApi}/progress`;
  }
  forceStopKejarCuanConfiguration() {
    return `${this.kejarCuanApi()}/stop-campaign`;
  }
  getInformationDetailKejarcuan(campaignId: number, posId: number) {
    return `/hydra/v1/kejarcuan/detail?campaign_id=${campaignId}&pos_id=${posId}`;
  }

  editKejarCuanConfiguration(id: number) {
    return `${this.kejarCuanApi()}/${id}`;
  }

  // instant booking
  getDetailInstantBooking() {
    return "/hydra/v1/instant-booking/detail";
  }
  createInstantBookingSession() {
    return "/hydra/v1/instant-booking/create";
  }
  updateSessionInstantBooking() {
    return "/hydra/v1/instant-booking/update";
  }

  // send email
  sendPrintReceiptEmail() {
    return "/hydra/v1/stt/resi-send-email";
  }

  // external api
  getDetailSttExternal(sttNo: string, clientId: string) {
    return `/hydra/v2/stt/resi/external?stt_no=${sttNo}&client_id=${clientId}`;
  }

  clientManagementGeneral(params: RequestListClientManagement) {
    return `/horde/${
      params.version
    }/client/management/general?${params.toQueryString()}`;
  }

  // NGEN
  loginNGen(): string {
    return "/hydra/v1/ngen/token";
  }
  getScheduleListNGen(): string {
    return String(process.env.VUE_APP_NGEN_GENESIS_SEARCH_FLIGHT_PATH);
  }
  getNGenSearchFlightV3() {
    return String(FlagsPermissionCargo.config_ngen_search_flight_path.getValue());
  }
  getTrackingCargoHistoryNgen() {
    return "/api/api/Tracking/AWB";
  }
  printAWBLionCargo(): string {
    if (IS_NGEN_V2) {
      return "/api/api/PortToDoorIntegration/PortToDoorAWbPrint";
    }
    return "/nGenAPI/api/PortToDoorIntegration/PortToDoorAWbPrint";
  }

  // MIDDLEWARE
  getShipmentDetailMiddleWare(ticketCode: string) {
    return `/elexys/shipment?q=${encodeURIComponent(ticketCode)}`;
  }

  getLastSyncSttReport() {
    return `/hydra/v2/report/sync`;
  }

  getDetailStiDest(id: number, version = "v1") {
    return `/hydra/${version}/sti-dest/detail/${id}`;
  }

  getListBalanceTransaction(params: RequestListBalanceTransaction) {
    return `gober/${
      params.apiVersion
    }/transaction/balance?${params.toQueryString()}`;
  }

  getBalanceTransactionType(apiVersion: string) {
    return `gober/${apiVersion}/transaction/type`;
  }

  getDetailForwardBookingCommission(id: any) {
    return `horde/v1/configurable/forward_booking_commission/${id}`;
  }

  // Payment Method
  validatePayment() {
    return "hydra/v1/checkout/validate";
  }
  checkInquiry(idTransaction: string) {
    return `gober/v1/checkout/check/${idTransaction}`;
  }
  getPaymentMethod(params: RequestListPaymentMethod) {
    return `gober/v1/payment_method?${params.toQueryString()}`;
  }

  // incoming & outgoing
  getDownloadIncomingOutgoing(params: RequestDownloadIncomingOutgoing) {
    return `hydra/v1/incoming-outgoing?${params.toQueryString()}`;
  }

  // get estimation service level agreement
  getEstimationServiceLevelAgreement(
    params: RequestEstimationServiceLevelAgreement
  ) {
    return `horde/v1/predefine_holiday?${params.toQueryString()}`;
  }
  getEstimateSlaDetail(params: RequestEstimateSlaDetail) {
    return `horde/v2/estimate/sla/detail?${params.toQueryString()}`;
  }

  // checking phone number
  phoneNumberCheck(phoneNumber: string) {
    return `hydra/v1/stt/phone_checker?phone_number=${phoneNumber}`
  }

  // total stt paid
  totalSTTPaidUnread(params?: RequestSttPaidUnread) {
    return `hydra/v1/read-stt-paid?${params?.toQueryString() ?? ""}`;
  }
  getDownloadStt(params: RequestListBooking) {
    return `hydra/v1/stt/payment/download?${params.toQueryString()}`;
  }

  // flagging dex
  validateRebuttalDex() {
    return "hydra/v1/rebuttal-dex";
  }

  getSummaryDownload(type: string, filter: DownloadSummaryCodRequest, version = "v1") {
    return `/hydra/${version}/dashboard-delivery/download/${type}/summary?${filter.toQueryString()}&hub_id=${getHubData()?.hubId || 0}`;
  }

  getDetailCourierData(queryString = "", type: string) {
    return `/hydra/${FlagsDashboardCod.feature_api_version_dashboard_delivery_summary_courier_cod.getValue()}/dashboard-delivery/summary/${type}/cod?${queryString}`;
  }

  getBonusKomisiDetail(params: BonusKomisiDetailRequest) {
    return `/hydra/v1/progressive-commission/detail?${params.toQueryString()}`;
  }

  getProgressiveCommissionList(params: ProgressiveCommissionListRequest) {
    return `/horde/v1/configurable_progressive_commission?${params.toQueryString()}`;
  }

  progressiveCommissionConfigApi(id = "") {
    return `/horde/v1/configurable_progressive_commission${
      !!id ? `/${id}` : ""
    }`;
  }

  getDownloadCourierData(
    driverPhone: string,
    filter: CodDashboardCourierDetailRequest,
    version = "v1"
  ) {
    return `/hydra/${version}/dashboard-delivery/download/courier?${filter.toQueryString()}&driver_phone=${driverPhone}&hub_id=${getHubData()?.hubId || 0}`;
  }

  getDownloadPicData(
    picPhone: string,
    filter: CodDashboardCourierDetailRequest
  ) {
    return `/hydra/v1/dashboard-delivery/download/pic?${filter.toQueryString()}&pic_phone=${picPhone}`;
  }

  getDetailCourierPerStatusCodDashboard(
    params: CodDashboardCourierDetailRequest
  ) {
    return `/hydra/${FlagsDashboardCod.feature_api_version_dashboard_delivery_detail_courier_cod.getValue()}/dashboard-delivery/detail/${
      params.type
    }/cod?${params.toQueryString()}`;
  }

  getTaskSettlementCourier(params: TaskSettlementCourierParams): string {
    return `/hydra/v1/dashboard-delivery/courier/${params.id}/task-settlement?${params.toQueryString()}`
  }

  getTaskSettlementCourierDetail(id: number): string {
    return `/hydra/v1/dashboard-delivery/task-settlement/${id}`;
  }

  getProgressiveCommissionDetail(id: number) {
    return `/horde/v1/configurable_progressive_commission/detail/${id}`;
  }

  getDetailClientBookingTemplate(id: number) {
    return `/horde/v1/bulk-booking-template/detail/${id}`;
  }

  getListClientBookingTemplate(params: ClientBookingListParams) {
    return `/horde/v1/bulk-booking-template/client/list?${params.toQueryString()}`;
  }

  editClientTemplateConfiguration(id: number) {
    return `/horde/v1/bulk-booking-template/${id}`;
  }

  createClientTemplateConfiguration() {
    return `/horde/v1/bulk-booking-template`;
  }

  getBaggingGroupingList(params: RequestBaggingGroupingList) {
    return `/horde/v1/bagging_group_location?${params.toQueryString()}`;
  }

  getDetailClaim(sttNo: string) {
    return `/hydra/v1/claim-status/detail?stt_no=${sttNo}`;
  }

  createTrackDeliveryClaim() {
    return "/phoenix/v1/claim-status";
  }

  getDataClaimList(path: string, params: ClaimListRequest) {
    return `/hydra/v1/${path}?${params.toQueryString()}`;
  }

  // SALDO & POIN SENDER DASHBOARD
  getListHistoryPoint(params: RequestHistoryPoinSaldoList) {
    return `/phoenix/v1/point/history?${params.toQueryString()}`;
  }

  getListHistorySaldo(params: RequestHistoryPoinSaldoList) {
    return `/phoenix/v1/balance/history?${params.toQueryString()}`;
  }

  getDataTrackList(path: string, filter: TrackDeliveryListRequest) {
    return `/hydra/v1/${path}?${filter.toQueryString()}`;
  }
  // cargo configuration
  getDetailCargoConfiguration(id: number) {
    return `/horde/v1/cargo-configuration/${id}`;
  }
  editCargoConfiguration(): string {
    return "/horde/v1/cargo-configuration";
  }
  deleteCargoConfiguration(id: number): string {
    return `/horde/v1/cargo-configuration/${id}`;
  }
  getCargoRecomendations(params: CargoRecomendationsListRequest): string {
    return `/horde/v1/cargo-configuration/recommendation?${params.toQueryString()}`;
  }
  getLastReadCargo() {
    return `/hydra/v1/retry_cargo/check`;
  }
  getLastIdRetryCargo(params: CargoListRequest) {
    return `/hydra/v1/retry_cargo/last-id?${params.toQueryString()}`;
  }

  updateLastReadCargo() {
    return `/hydra/v1/retry_cargo/last_view`;
  }

  addCargoConfiguration() {
    return `/horde/v1/cargo-configuration`;
  }
  getCargoConfigList(params: CargoConfigListRequest) {
    return `/horde/v1/cargo-configuration?${params.toQueryString()}`;
  }

  // getCargoConfigV2List(params: CargoConfigV2ListRequest) {
  //   return `/horde/v2/cargo-configuration?${params.toQueryString()}`;
  // }

  getCargoConfigV2Detail(id: number) {
    return `/horde/v2/cargo-configuration/${id}`;
  }

  getDutyTaxConfigurationList(params: DutyTaxConfigurationListRequest) {
    return `/horde/v1/duty_tax_configuration?${params.toQueryString()}`;
  }

  resolveDutyTaxConfiguration() {
    return `/horde/v1/duty_tax_configuration/resolve`;
  }

  addCargoConfigV2() {
    return `/horde/v2/cargo-configuration`;
  }

  updateCargoConfigV2(id: number) {
    return `/horde/v2/cargo-configuration/${id}`;
  }

  downloadCargoConfigV2() {
    return `/horde/v2/cargo-configuration/download-csv`;
  }

  getListCargoConfigBulkDownload(params: ReportListDownloadRequest) {
    return `/horde/v1/report/bulk-download?${params.toQueryString()}`;
  } 

  // searchCargoConfigFlight(params: CargoConfigV2SearchFlightRequest) {
  //   return `/horde/v1/cargo-configuration/search-flight?${params.toQueryString()}`;
  // }

  getReferralAffiliate() {
    return `/horde/v1/partner/affiliate-link`;
  }

  getDistrictClient(params: {
    id: number | string;
    args: DistrictClientRequest;
  }): string {
    return `/horde/v1/district/client/${
      params.id
    }?${params.args.toQueryString()}`;
  }

  getListRegion(params: RegionListRequest) {
    return `/horde/v1/region?${params.toQueryString()}`;
  }

  checkServiceDelay(): string {
    return "/horde/v1/service_delay/check";
  }

  // service delay network
  getServiceDelayList(params: ApiRequestList) {
    return `/horde/v1/service_delay?${params.toQueryString()}`;
  }
  getServiceDelayDetail(id: number) {
    return `/horde/v1/service_delay/${id}`;
  }
  serviceDelayForm() {
    return "/horde/v1/service_delay";
  }

  // courier management
  getCourierManagementList(params: ApiRequestCourierManagementList) {
    return `/horde/v1/courier_management?${params.toQueryString()}`;
  }
  getCourierManagementApprovalList(params: ApiRequestCourierManagementList) {
    return `/horde/v1/partner/courier-approval-delivery?${params.toQueryString()}`;
  }
  getCourierManagementApprovalListHistory(
    params: ApiRequestCourierManagementListHistory,
    id: number
  ) {
    console.log(id, "id endpoint");
    return `/horde/v1/partner/courier-approval-delivery/history/courier/${id}?${params.toQueryString()}`;
  }
  downloadCourierManagementList(params: ApiRequestCourierManagementList) {
    return `/horde/v1/courier_management/export_csv?${params.toQueryString()}`;
  }
  createCourierManagement() {
    return "/horde/v1/courier_management";
  }
  getCourierManagementDetail(id: number) {
    return `/horde/v1/courier_management/${id}`;
  }
  getCourierManagementDetailDeviceList(id: number) {
    return `/horde/v1/courier_management/${id}/device-manager`;
  }
  logoutDeviceCourier(id: number) {
    return `/horde/v1/courier_management/${id}/device-manager/logout`;
  }
  updateStatusCourierManagement() {
    return `/horde/v1/partner/courier-approval-delivery/update-status`;
  }
  getCourierVehicleList(params: ApiRequestCourierVehicleList): string {
    return `/horde/v1/courier_management/vehicle?${params.toQueryString()}`;
  }
  getCourierShuttleList(params: CourierShuttleListRequest) {
    return `/horde/v1/partner/courier-shuttle?${params.toQueryString()}`;
  }

  // config price cod
  getConfigPriceCodDetail(id: number): string {
    return `/horde/v1/configurable/cod/${id}`;
  }

  // cod configuration
  getCodConfigurationList(params: ApiRequestList) {
    return `/horde/v1/cod_configuration?${params.toQueryString()}`;
  }

  getCodConfigurationDetail(id: number) {
    return `/horde/v1/cod_configuration/${id}`;
  }

  // balance minus penalty
  getBalanceMinusPenalty(params: ApiRequestList) {
    return `/horde/v1/balance_minus_penalty?${params.toQueryString()}`;
  }

  getBalanceMinusPenaltyDetail(id: number) {
    return `/horde/v1/balance_minus_penalty/${id}`;
  }
  getAllNotifications() {
    return `/hydra/v1/notification-penalty/list`;
  }
  getBalancePenaltyNotification() {
    return "/hydra/v1/notification-penalty/last";
  }

  // hold balance history
  getHoldBalanceHistoryList(params: ApiRequestList) {
    return `/hydra/v1/hold_balance_history?${params.toQueryString()}`;
  }

  postToGetPosterProduct() {
    return `/horde/v1/tariff/upselling`;
  }

  getListMiddleware(type: string, params: RequestMiddlewareList) {
    return `v2/api/internal/${type}?${params.toQueryString()}`;
  }

  formMiddleware(type: string, id: number) {
    return `v2/api/internal/${type}${id ? `/${id}` : ""}`;
  }

  getDetailMiddleware(params: { type: string; id: number }) {
    return `v2/api/internal/${params.type}/${params.id}`;
  }

  getTokenMiddleware() {
    return `/horde/v1/auth/pegasus`;
  }

  uploadHydraFile() {
    return `/hydra/v1/upload`;
  }

  deleteHydraFile() {
    return `/hydra/v1/upload/delete`;
  }

  getListIntegrationToken(params: ApiRequestList) {
    return `v2/client/integration-tokens?${params.toQueryString()}`
  }

  addGenerateToken() {
    return "v2/client/integration-tokens"
  }

  // HYDRA v2 Upload Endpoints
  uploadHydraFileV2() {
    return `/hydra/v2/upload`;
  }

  deleteHydraFileV2() {
    return `/hydra/v2/upload/delete`;
  }

  getTopupFeeConfigList(params: RequestTopupFeeConfigurationList) {
    return `/horde/v1/configurable-top-up-fee?${params.toQueryString()}`;
  }

  detailTopupFeeConfig(id: any) {
    return `/horde/v1/configurable-top-up-fee/${id}`;
  }

  saveTopupFeeConfig() {
    return `/horde/v1/configurable-top-up-fee`;
  }

  getActiveTopupFeeConfig(id: any) {
    return `/horde/v1/configurable-top-up-fee/active-retail/${id}`;
  }
  getTrackingByBookingRequestIdNgen() {
    return "/api/Booking/v3/Tracking";
  }

  // Urgent Delivery Management Endpoints
  getUrgentDeliveryManagementPODList(
    params: UrgentDeliveryManagementPODListRequest
  ): string {
    return `/hydra/v1/priority-delivery-management/pod?${params.toQueryString()}`;
  }

  getUrgentDeliveryManagementPODSummary(
    params: UrgentDeliveryManagementPODSummaryRequest
  ): string {
    return `/hydra/v1/priority-delivery-management/pod/summary?${params.toQueryString()}`;
  }

  getPriorityDeliveryLastLocationOptions(): string {
    return "/hydra/v1/priority-delivery-management/last-location-options";
  }

  getUrgentDeliveryManagementRTSList(
    params: UrgentDeliveryManagementRTSListRequest
  ): string {
    return `/hydra/v1/priority-delivery-management/rts?${params.toQueryString()}`;
  }

  getUrgentDeliveryManagementHALList(
    params: UrgentDeliveryManagementHALListRequest
  ): string {
    return `/hydra/v1/priority-delivery-management/hal?${params.toQueryString()}`;
  }

  getUrgentDeliveryManagementTakenByRecipientList(
    params: UrgentDeliveryManagementHALListRequest
  ): string {
    return `/hydra/v1/priority-delivery-management/taken-by-recipient?${params.toQueryString()}`;
  }

  getUrgentDeliveryManagementRelabelList(
    params: UrgentDeliveryManagementRelabelListRequest
  ): string {
    return `/hydra/v1/priority-delivery-management/relabel?${params.toQueryString()}&is_total_data=true`;
  }

  downloadUrgentManagementList(
    status: "pod" | "rts" | "hal" | "missing" | "relabel",
    params:
      | UrgentDeliveryManagementPODListRequestDownload
      | UrgentDeliveryManagementRTSListRequestDownload
      | UrgentDeliveryManagementHALListRequestDownload
      | UrgentDeliveryManagementMissingListRequestDownload
      | UrgentDeliveryManagementRelabelListRequestDownload
  ): string {
    return `/hydra/v1/priority-delivery-management/download/${status}?${params.toQueryString()}`;
  }

  // STI Reverse Scan Endpoints
  getSTIReverseScanTemporaryList(
    params: STIReverseScanTemporaryListRequest
  ): string {
    return `/hydra/v2/sti/temporary?${params.toQueryString()}`;
  }

  generateSTIReverseScan(): string {
    return `/hydra/v2/sti/generate`;
  }

  getSTIReverseScanDetail(id: number): string {
    return `/hydra/v2/sti/pdf/${id}`;
  }

  saveUserConsent() {
    return "/horde/v1/user-consent";
  }

  getSTISTTDueSummary(params: STISTTDueSummaryListRequest): string {
    return `/hydra/v1/stt-due/STI/summary?${params.toQueryString()}`;
  }

  getSummaryStiCycle(params: STISTTDueSummaryListRequest): string {
    return `/hydra/v1/summary/STI/cycle?${params.toQueryString()}`;
  }

  getSTISCSTTDueSummary(): string {
    return `/hydra/v1/stt-due/STI-SC/summary`;
  }

  getSTIBookedList() {
    return "/hydra/v1/stt-due/STI/list-booked?page=1&limit=500&is_total_data=true";
  }

  getSTIScBookedList() {
    return "/hydra/v1/stt-due/STI-SC/list-booked?page=1&limit=500&is_total_data=true";
  }

  getSTIScSTTDueList(params: STIScSTTDueListRequest) {
    return `/hydra/v1/stt-due/STI-SC?${params.toQueryString()}`;
  }

  getSTISTTDueList(params: STISTTDueListRequest) {
    return `/hydra/v1/stt-due/STI?${params.toQueryString()}`;
  }

  downloadSTISTTDue(params: STISTTDueListRequest) {
    return `/hydra/v1/stt-due/STI/excel?${params.toQueryString()}`;
  }

  downloadSTIScSTTDue(params: STIScSTTDueListRequest) {
    return `/hydra/v1/stt-due/STI-SC/excel?${params.toQueryString()}`;
  }

  getCollectibleCard() {
    return '/phoenix/v1/campaign/collectible-item'
  }

  detailCollectibleCard(imageId: number) {
    return `/phoenix/v1/campaign/collectible-item/detail?image_id=${imageId}`;
  }

  // COD Reconcile Endpoints
  getCourierSummaryDetailV2(params: CourierDetailApiRequest, version: string) {
    return `/hydra/${version}/dashboard-delivery/courier/summary?${params.toQueryString()}`;
  }

  getDetailCourierSummary(params: CourierDetailApiRequest) {
    return `/hydra/v2/dashboard-delivery/summary/courier/cod?${params.toQueryString()}`
  }

  getDetailCourierCodV2(params: CourierDetailApiRequest, version: string) {
    return `/hydra/${version}/dashboard-delivery/detail/courier/cod?${params.toQueryString()}`;
  }

  getDetailCourierPendingReconcile(params: CourierDetailApiRequest, version: string) {
    return `/hydra/${version}/dashboard-delivery/detail/courier/pending-reconcile?${params.toQueryString()}`;
  }

  getDetailCourierByPhone(phone: string) {
    return `/hydra/v2/dashboard-delivery/detail/courier/${phone}`
  }

  getCourierNotes(courierId: number) {
    return `/hydra/v1/dashboard-delivery/courier/${courierId}/notes`
  }

  getCourierHistory(courierId: number, reconcileFor: string) {
    return `/hydra/v1/dashboard-delivery/courier/${courierId}/history?reconcile_for=${reconcileFor}`
  }

  getRTCListClientParent(hubId: number, transportType: string) {
    return `hydra/v1/ready-to-cargo/list-client-parent?hub_id=${hubId}&transport_type=${transportType}`;
  }

  getCourierSummaryDetail(type: string, phone: string, version: string) {
    return `/hydra/${version}/dashboard-delivery/courier/summary?type=${type}&phone=${phone}&hub_id=${getHubData()?.hubId || 0}`;
  }

  getExportFileExcel(params: RequestExportFileExcel) {
      return `/hydra/${params.version}/handover/excel/${params.toIDString()}`;
  }

  // STI-SC Reverse Scan Endpoints
  getSTISCReverseScanTemporary(params: STISCReverseScanTemporaryListRequest): string {
    return `/hydra/v2/sti/sc/temporary?${params.toQueryString()}`
  }

  createSTISCReverseScan() {
    return "/hydra/v2/sti/sc/scan"
  }

  getStiScSttDueSummary(params: STISCSTTDueSummaryRequest) {
    return `/hydra/v1/summary/STI-SC/cycle?${params.toQueryString()}`;
  }

  stiScReverseScanManifest() {
    return `/hydra/v2/sti/sc/manifest`
  }

  getPriorityDeliveryManagementDetail(id: number) {
    return `/hydra/v1/priority-delivery-management/detail/${id}`;
  }

  getAwbValidation() {
    return "/hydra/v1/cargo/awb-validation";
  }

  getListDeviceAuth(): string {
    return "horde/v1/device-auth/me";
  }

  deviceAuthReview() {
    return "/horde/v1/device-auth/review";
  }

  getListProduct(
    search: string,
    page: number,
    limit: number,
    status = ""
  ): string {
    const params = [
      `search=${encodeURIComponent(search)}`,
      `page=${page}`,
      `limit=${limit}`,
    ];
    if (status) params.push(`status=${status}`);
    return `/horde/v1/product?${params.join("&")}`;
  }

  getCommodityListV1(
    search: string,
    page: number,
    limit: number,
    status = ""
  ): string {
    const params = [
      `search=${encodeURIComponent(search)}`,
      `page=${page}`,
      `limit=${limit}`,
    ];
    if (status) params.push(`status=${status}`);
    return `/horde/v1/commodity?${params.join("&")}`;
  }

  getCargoMinimumWeightSummary(params: CargoMinimumWeightSummaryApiRequest) {
    return `/hydra/v1/cargo/minimum-volume-summary?${params.toQueryString()}`
  }

  downloadMinimumVolume() {
    return `/hydra/v1/cargo/minimum-volume-download`
  }

  getSummaryInProcess(params: CargoSummaryInProcessRequest) {
    return `/hydra/v1/retry_cargo/summary-in-process?${params.toQueryString()}`;
  }

  checkEligibleReadyToCargo(): string {
    return `/hydra/v1/ready-to-cargo/check-eligible`;
  }

  bulkErrorReport(id: number): string {
    return `/horde/v1/report/client-rate-bulk-error/${id}`
  }
}
